export enum FORM_NAME {
  CREATE_NOTIFICATION = 'CREATE_NOTIFICATION',
  UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION',
}
